import { render, staticRenderFns } from "./CreateUserCard.vue?vue&type=template&id=571642a9&"
import script from "./CreateUserCard.vue?vue&type=script&lang=js&"
export * from "./CreateUserCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports